import http from '@/utils/request';
import { Message } from 'element-ui';

export default {
  methods: {
    exportByBlob(config) {
      let {
        filename,
      } = config;
      const { url, data = {}, params = {}, method = 'post' } = config;

      return new Promise((resolve, reject) => {
        http[method]({
          url,
          data,
          params,
          responseType: 'blob',
          // eslint-disable-next-line consistent-return
        }).then((res) => {
          const response = res?.data;
          if (response.type === 'application/json') {
            const reader = new FileReader();
            reader.readAsText(response, 'utf-8');
            reader.onload = () => {
              let result = '';
              try {
                result = JSON.parse(reader.result);
              } catch (e) {
                console.log(e);
                result = response;
              }
              Message.error((result && result.message) || '导出失败');
              reject(result);
            };
          } else {
            try {
              const { headers } = res; // 下载后文件名
              const contentDisposition = headers['content-disposition'];
              const responseFilename = decodeURIComponent(contentDisposition.split(';')[1].split('filename=')[1]);
              // 有传文件名称&不带后缀 使用服务端的文件拓展名
              if (filename && !filename.includes('.')) {
                const splitFileName = responseFilename.split('.');
                const suffix = splitFileName[splitFileName.length - 1];
                filename += `.${suffix}`;
              } else if (!filename) {
                filename = responseFilename;
              }
            } catch (e) {
              // 默认名称
              console.log(e);
              if (!filename) {
                filename = 'download.xlsx';
              }
            }
            const blob = new Blob([res.data]);
            const downloadElement = document.createElement('a');
            const href = window.URL.createObjectURL(blob); // 创建下载的链接
            downloadElement.href = href;
            downloadElement.download = filename;
            document.body.appendChild(downloadElement);
            downloadElement.click(); // 点击下载
            document.body.removeChild(downloadElement); // 下载完成移除元素
            window.URL.revokeObjectURL(href);
            resolve(res);
          }
        }).catch((e) => {
          console.log(e);
          reject(e);
        });
      });
    },
  },
};
